import React, { useState, useEffect } from 'react';

import { FirebaseAuthentication } from 'services/firebase';

import UserModel from 'domain/user/UserModel';

import logout from './usecases/logout';

export const AuthenticationContext = React.createContext();

const userKey = 'user';

const AuthenticationProvider = ({ children }) => {
  const persistedUserString = localStorage.getItem(userKey);
  const [user, setUser] = useState(
    persistedUserString ? UserModel.fromString(persistedUserString) : null
  );
  const [isAuthenticated, setIsAuthenticated] = useState(!!persistedUserString);

  useEffect(() => {
    const unsubscribe = FirebaseAuthentication().onAuthStateChanged((user) => {
      if (user) {
        if (!user.emailVerified) logout();
        else if (!isAuthenticated) _authenticate(user);
      } else {
        if (isAuthenticated) _unauthenticate();
      }
    });

    return () => {
      unsubscribe();
    };
  }, [isAuthenticated]);

  const _authenticate = (userFirebase) => {
    const newUser = UserModel.fromFirebaseUserModel(userFirebase);
    setUser(newUser);
    setIsAuthenticated(true);
    localStorage.setItem(userKey, newUser.serialize());
  };

  const _unauthenticate = () => {
    setIsAuthenticated(false);
    setUser(null);
    localStorage.removeItem(userKey);
  };

  return (
    <AuthenticationContext.Provider value={{ isAuthenticated, user }}>
      {children}
    </AuthenticationContext.Provider>
  );
};

export default AuthenticationProvider;
